import React from 'react';
import { Inventory } from '../../models';
import ZoneInventoryModel from '../../models/zoneInventoryModel';
import { useTranslation } from 'react-i18next';
import { WeezHeader, Card, SplitContainer, Select, MiniTab, Loader } from '@weezevent/nacre';
import Style from './quotas.module.css';

// Render functions (to be replaced later)
function renderRates() {
    return <div>Rates content</div>;
}
function renderZones() {
    return <div>Zones content</div>;
}
function renderContingents() {
    return <div>Contingents content</div>;
}

export default function Quotas({ organization, event }) {
    const { t } = useTranslation();

    const [currentInventory, setCurrentInventory] = React.useState(null);
    const [activeTab, setActiveTab] = React.useState('rates');

    const [inventories, loadingInventories] = Inventory.useApiModel(
        {
            organizationId: organization.id,
            chartId: event.chart,
            onSuccess: response => {
                // Always select the first inventory returned
                setCurrentInventory(response[0]?.uuid);
            }
        },
        [organization.id, event.chart]
    );

    const [zones, loadingZones] = ZoneInventoryModel.useApiModel(
        {
            organizationId: organization.id,
            chartId: event.chart,
            inventoryId: currentInventory,
            launch: Boolean(currentInventory)
        },
        [organization.id, event.chart, currentInventory]
    );

    const handleChange = React.useCallback(inventory => {
        setCurrentInventory(inventory);
    }, []);

    const inventoriesOptions = React.useMemo(() => {
        return inventories?.map(inventory => ({ text: inventory.name, value: inventory.uuid }));
    }, [inventories]);

    // Disable tabs logic
    const disabledZones = React.useMemo(() => {
        // Disable if inventories haven't loaded yet
        if (!inventories || inventories.length === 0) return true;
        if (inventories.length > 1 || event.is_seated) return false;
    }, [inventories, event]);

    const disabledContingents = React.useMemo(() => {
        // Disable if zones haven't loaded yet
        if (!zones || zones.length === 0) return true;

        // Enable if at least one zone is seated
        const hasSeatedZone = zones.some(zone => zone.is_seated);
        return !hasSeatedZone;
    }, [zones]);

    if (loadingInventories || loadingZones) {
        return <Loader />;
    }

    return (
        <div>
            <WeezHeader title={t('ticket.quotas.title')}>{t('ticket.quotas.subtitle')}</WeezHeader>
            <SplitContainer additional={<div></div>}>
                <Card>
                    <Card.Header>
                        <Card.Title>{t('ticket.quotas.section-title')}</Card.Title>
                    </Card.Header>
                    <Card.Content>
                        <div className={Style['quotas-inventory-switch']}>
                            <Select onChange={handleChange} options={inventoriesOptions} value={currentInventory} placeholder={t('ticket.common.action.select')} />
                            <MiniTab
                                panes={[
                                    { label: t('ticket.common.rates'), value: 'rates' },
                                    { label: t('ticket.common.zones'), value: 'zones', disabled: disabledZones },
                                    { label: t('ticket.common.contingents'), value: 'contingents', disabled: disabledContingents }
                                ]}
                                activeTab={activeTab}
                                onTabSelected={tab => {
                                    setActiveTab(tab.value);
                                }}
                            />
                        </div>
                        {activeTab === 'rates' && renderRates()}
                        {activeTab === 'zones' && renderZones()}
                        {activeTab === 'contingents' && renderContingents()}
                    </Card.Content>
                </Card>
            </SplitContainer>
        </div>
    );
}
